import * as tslib_1 from "tslib";
import { mapHash, Splitter, memoize } from '@fullcalendar/core';
import { __assign } from 'tslib';
var AbstractResourceDayTable = /** @class */ (function () {
    function AbstractResourceDayTable(dayTable, resources) {
        this.dayTable = dayTable;
        this.resources = resources;
        this.resourceIndex = new ResourceIndex(resources);
        this.rowCnt = dayTable.rowCnt;
        this.colCnt = dayTable.colCnt * resources.length;
        this.cells = this.buildCells();
    }
    AbstractResourceDayTable.prototype.buildCells = function () {
        var _a = this, rowCnt = _a.rowCnt, dayTable = _a.dayTable, resources = _a.resources;
        var rows = [];
        for (var row = 0; row < rowCnt; row++) {
            var rowCells = [];
            for (var dateCol = 0; dateCol < dayTable.colCnt; dateCol++) {
                for (var resourceCol = 0; resourceCol < resources.length; resourceCol++) {
                    var resource = resources[resourceCol];
                    var htmlAttrs = 'data-resource-id="' + resource.id + '"';
                    rowCells[this.computeCol(dateCol, resourceCol)] = {
                        date: dayTable.cells[row][dateCol].date,
                        resource: resource,
                        htmlAttrs: htmlAttrs
                    };
                }
            }
            rows.push(rowCells);
        }
        return rows;
    };
    return AbstractResourceDayTable;
}());
export { AbstractResourceDayTable };
/*
resources over dates
*/
var ResourceDayTable = /** @class */ (function (_super) {
    tslib_1.__extends(ResourceDayTable, _super);
    function ResourceDayTable() {
        return _super !== null && _super.apply(this, arguments) || this;
    }
    ResourceDayTable.prototype.computeCol = function (dateI, resourceI) {
        return resourceI * this.dayTable.colCnt + dateI;
    };
    /*
    all date ranges are intact
    */
    ResourceDayTable.prototype.computeColRanges = function (dateStartI, dateEndI, resourceI) {
        return [
            {
                firstCol: this.computeCol(dateStartI, resourceI),
                lastCol: this.computeCol(dateEndI, resourceI),
                isStart: true,
                isEnd: true
            }
        ];
    };
    return ResourceDayTable;
}(AbstractResourceDayTable));
export { ResourceDayTable };
/*
dates over resources
*/
var DayResourceTable = /** @class */ (function (_super) {
    tslib_1.__extends(DayResourceTable, _super);
    function DayResourceTable() {
        return _super !== null && _super.apply(this, arguments) || this;
    }
    DayResourceTable.prototype.computeCol = function (dateI, resourceI) {
        return dateI * this.resources.length + resourceI;
    };
    /*
    every single day is broken up
    */
    DayResourceTable.prototype.computeColRanges = function (dateStartI, dateEndI, resourceI) {
        var segs = [];
        for (var i = dateStartI; i <= dateEndI; i++) {
            var col = this.computeCol(i, resourceI);
            segs.push({
                firstCol: col,
                lastCol: col,
                isStart: i === dateStartI,
                isEnd: i === dateEndI
            });
        }
        return segs;
    };
    return DayResourceTable;
}(AbstractResourceDayTable));
export { DayResourceTable };
var ResourceIndex = /** @class */ (function () {
    function ResourceIndex(resources) {
        var indicesById = {};
        var ids = [];
        for (var i = 0; i < resources.length; i++) {
            var id = resources[i].id;
            ids.push(id);
            indicesById[id] = i;
        }
        this.ids = ids;
        this.indicesById = indicesById;
        this.length = resources.length;
    }
    return ResourceIndex;
}());
export { ResourceIndex };
/*
TODO: just use ResourceHash somehow? could then use the generic ResourceSplitter
*/
var VResourceSplitter = /** @class */ (function (_super) {
    tslib_1.__extends(VResourceSplitter, _super);
    function VResourceSplitter() {
        return _super !== null && _super.apply(this, arguments) || this;
    }
    VResourceSplitter.prototype.getKeyInfo = function (props) {
        var resourceDayTable = props.resourceDayTable;
        var hash = mapHash(resourceDayTable.resourceIndex.indicesById, function (i) {
            return resourceDayTable.resources[i]; // has `ui` AND `businessHours` keys!
        }); // :(
        hash[''] = {};
        return hash;
    };
    VResourceSplitter.prototype.getKeysForDateSpan = function (dateSpan) {
        return [dateSpan.resourceId || ''];
    };
    VResourceSplitter.prototype.getKeysForEventDef = function (eventDef) {
        var resourceIds = eventDef.resourceIds;
        if (!resourceIds.length) {
            return [''];
        }
        return resourceIds;
    };
    return VResourceSplitter;
}(Splitter));
export { VResourceSplitter };
// joiner
var NO_SEGS = []; // for memoizing
var VResourceJoiner = /** @class */ (function () {
    function VResourceJoiner() {
        this.joinDateSelection = memoize(this.joinSegs);
        this.joinBusinessHours = memoize(this.joinSegs);
        this.joinFgEvents = memoize(this.joinSegs);
        this.joinBgEvents = memoize(this.joinSegs);
        this.joinEventDrags = memoize(this.joinInteractions);
        this.joinEventResizes = memoize(this.joinInteractions);
    }
    /*
    propSets also has a '' key for things with no resource
    */
    VResourceJoiner.prototype.joinProps = function (propSets, resourceDayTable) {
        var dateSelectionSets = [];
        var businessHoursSets = [];
        var fgEventSets = [];
        var bgEventSets = [];
        var eventDrags = [];
        var eventResizes = [];
        var eventSelection = '';
        var keys = resourceDayTable.resourceIndex.ids.concat(['']); // add in the all-resource key
        for (var _i = 0, keys_1 = keys; _i < keys_1.length; _i++) {
            var key = keys_1[_i];
            var props = propSets[key];
            dateSelectionSets.push(props.dateSelectionSegs);
            businessHoursSets.push(key ? props.businessHourSegs : NO_SEGS); // don't include redundant all-resource businesshours
            fgEventSets.push(key ? props.fgEventSegs : NO_SEGS); // don't include fg all-resource segs
            bgEventSets.push(props.bgEventSegs);
            eventDrags.push(props.eventDrag);
            eventResizes.push(props.eventResize);
            eventSelection = eventSelection || props.eventSelection;
        }
        return {
            dateSelectionSegs: this.joinDateSelection.apply(this, [resourceDayTable].concat(dateSelectionSets)),
            businessHourSegs: this.joinBusinessHours.apply(this, [resourceDayTable].concat(businessHoursSets)),
            fgEventSegs: this.joinFgEvents.apply(this, [resourceDayTable].concat(fgEventSets)),
            bgEventSegs: this.joinBgEvents.apply(this, [resourceDayTable].concat(bgEventSets)),
            eventDrag: this.joinEventDrags.apply(this, [resourceDayTable].concat(eventDrags)),
            eventResize: this.joinEventResizes.apply(this, [resourceDayTable].concat(eventResizes)),
            eventSelection: eventSelection
        };
    };
    VResourceJoiner.prototype.joinSegs = function (resourceDayTable) {
        var segGroups = [];
        for (var _i = 1; _i < arguments.length; _i++) {
            segGroups[_i - 1] = arguments[_i];
        }
        var resourceCnt = resourceDayTable.resources.length;
        var transformedSegs = [];
        for (var i = 0; i < resourceCnt; i++) {
            for (var _a = 0, _b = segGroups[i]; _a < _b.length; _a++) {
                var seg = _b[_a];
                transformedSegs.push.apply(transformedSegs, this.transformSeg(seg, resourceDayTable, i));
            }
            for (var _c = 0, _d = segGroups[resourceCnt]; _c < _d.length; _c++) { // one beyond. the all-resource
                var seg = _d[_c];
                transformedSegs.push.apply(// one beyond. the all-resource
                transformedSegs, this.transformSeg(seg, resourceDayTable, i));
            }
        }
        return transformedSegs;
    };
    /*
    for expanding non-resource segs to all resources.
    only for public use.
    no memoizing.
    */
    VResourceJoiner.prototype.expandSegs = function (resourceDayTable, segs) {
        var resourceCnt = resourceDayTable.resources.length;
        var transformedSegs = [];
        for (var i = 0; i < resourceCnt; i++) {
            for (var _i = 0, segs_1 = segs; _i < segs_1.length; _i++) {
                var seg = segs_1[_i];
                transformedSegs.push.apply(transformedSegs, this.transformSeg(seg, resourceDayTable, i));
            }
        }
        return transformedSegs;
    };
    VResourceJoiner.prototype.joinInteractions = function (resourceDayTable) {
        var interactions = [];
        for (var _i = 1; _i < arguments.length; _i++) {
            interactions[_i - 1] = arguments[_i];
        }
        var resourceCnt = resourceDayTable.resources.length;
        var affectedInstances = {};
        var transformedSegs = [];
        var isEvent = false;
        var sourceSeg = null;
        for (var i = 0; i < resourceCnt; i++) {
            var interaction = interactions[i];
            if (interaction) {
                for (var _a = 0, _b = interaction.segs; _a < _b.length; _a++) {
                    var seg = _b[_a];
                    transformedSegs.push.apply(transformedSegs, this.transformSeg(seg, resourceDayTable, i) // TODO: templateify Interaction::segs
                    );
                }
                __assign(affectedInstances, interaction.affectedInstances);
                isEvent = isEvent || interaction.isEvent;
                sourceSeg = sourceSeg || interaction.sourceSeg;
            }
            if (interactions[resourceCnt]) { // one beyond. the all-resource
                for (var _c = 0, _d = interactions[resourceCnt].segs; _c < _d.length; _c++) {
                    var seg = _d[_c];
                    transformedSegs.push.apply(transformedSegs, this.transformSeg(seg, resourceDayTable, i) // TODO: templateify Interaction::segs
                    );
                }
            }
        }
        return {
            affectedInstances: affectedInstances,
            segs: transformedSegs,
            isEvent: isEvent,
            sourceSeg: sourceSeg
        };
    };
    return VResourceJoiner;
}());
export { VResourceJoiner };
